import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { Calendar, Clock, User, Shield } from 'lucide-react';

const CALENDAR_URL = '#'; // Placeholder — replace with actual Calendly URL

export default function BookingSection() {
  const { t } = useLanguage();
  const ref = useScrollReveal();

  const features = [
    { icon: Shield, label: t('booking.feature1') },
    { icon: User, label: t('booking.feature2') },
    { icon: Clock, label: t('booking.feature3') },
  ];

  return (
    <section id="booking" data-testid="booking-section" className="py-24 md:py-32 relative overflow-hidden">
      <div className="absolute inset-0 bg-[#0B1E2E]" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#1A4D75]/20 via-transparent to-[#1A4D75]/20" />
      <div className="hero-glow top-[-200px] left-1/2 -translate-x-1/2" />

      <div ref={ref} className="reveal relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center">
        <p className="text-sm uppercase tracking-widest text-[#42D2D9] font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
          {t('booking.caption')}
        </p>
        <div className="section-line mx-auto mb-8" />

        <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight text-white mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
          {t('booking.title')}
        </h2>
        <p className="text-base md:text-lg text-slate-300 mb-12 max-w-2xl mx-auto leading-relaxed">
          {t('booking.description')}
        </p>

        {/* Features */}
        <div className="flex flex-wrap justify-center gap-6 mb-12">
          {features.map((f, i) => {
            const Icon = f.icon;
            return (
              <div key={i} className="flex items-center gap-2 px-4 py-2 rounded border border-white/10 bg-white/5">
                <Icon className="w-4 h-4 text-[#42D2D9]" strokeWidth={1.5} />
                <span className="text-sm text-slate-300">{f.label}</span>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <a
          href={CALENDAR_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="booking-cta"
          className="cta-primary inline-flex items-center gap-3 text-base px-12 py-5"
        >
          <Calendar className="w-5 h-5 relative z-10" strokeWidth={1.5} />
          <span>{t('booking.cta')}</span>
        </a>
      </div>
    </section>
  );
}
